import Swal from "sweetalert2";
import { loginOutDB } from "../Logic/index01";

export function Format(string){
    return string.substring(0,1).toUpperCase() + string.substring(1)
}


export function roundUpToDecimal(value, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.ceil(value * factor) / factor;
}



export function construct(obj) {
  if(obj === null ){
     return undefined
  }
  let content = obj.toString().trim();
  if(obj.startsWith('{') && content.endsWith('}')){
    content = content.slice(1,-1);
  }

  const res = {}
  if(content.length === 0) return res;

  for(const pair of content.toString().split(/\s*,\s*/)){
    const[key,value] = pair.split('=')
    if(!key || value === undefined){
      return res;
    }
    res[key.trim()] = value.trim();
  }
  //console.log(res)
  return res ? res : undefined;
}



export function generateId(){
    return new Date().getMilliseconds() + new Date().getTime()
}



export  const messageDisplay = (val,email,send)  => {
      if(val == "Logout"){
            Swal.fire({
                title: "Are you sure?",
                text: "You wont to logout!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Logout"
              }).then((result) => {
                  if (result.isConfirmed) {
                       loginOutDB(email)
                       localStorage.removeItem(process.env.REACT_APP_LS);
                       localStorage.clear();
                       send("/signin")
                       
                  }
              });
              
    }else{
      Swal.fire({
        title: "Message",
        text: val,
        icon: email === 0 ? "success" : "error"
      });
    }
  }


  
  
  export const BT = [
    'Towing company',
    'Mechanic workshop',
    "School rider"
  ]
  

  
  
  
  
  export const State = [
  "Abuja",
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara"]
  
  
  
  export const T = {
    bg: "#f0f2f5",
    surface: "#ffffff",
    border: "#e8eaed",
    text: "#111827",
    muted: "#6b7280",
    subtle: "#9ca3af",
    blue: "#2563eb",
    blueLight: "#eff4ff",
    cyan: "#06b6d4",
    green: "#059669",
    greenLight: "#d1fae5",
    greenText: "#065f46",
    amber: "#d97706",
    amberLight: "#fef9c3",
    amberText: "#713f12",
    red: "#dc2626",
    redLight: "#fee2e2",
    redText: "#7f1d1d",
    purple: "#7c3aed",
    font: "'DM Sans', sans-serif",
    mono: "'DM Mono', monospace",
    buttonColor:"#1658EA",
    themeblue:"#00B4D8"
  };
  
  
  
  

  
  //cookieToMap().get('beepytoken')
  // export function cookieToMap() {
  //   const cookies = document.cookie;
  
  //   if (cookies === "") {
  //     return new Map();
  //   }
  //   // Split the string by semicolons to get individual cookie strings
  //   return new Map(
  //     cookies.split(';').map(cookieString => {
  //       // Trim any leading/trailing whitespace
  //       const trimmedCookie = cookieString.trim();
  //       // Find the index of the first equals sign
  //       const equalsIndex = trimmedCookie.indexOf('=');
  
  //       let key, value;
  //       if (equalsIndex === -1) {
  //         // Handle a cookie with no value (key only)
  //         key = decodeURIComponent(trimmedCookie);
  //         value = '';
  //       } else {
  //         // Extract and decode key and value
  //         key = decodeURIComponent(trimmedCookie.slice(0, equalsIndex));
  //         value = decodeURIComponent(trimmedCookie.slice(equalsIndex + 1));
  //       }
  
  //       // Return the key-value pair as an array for the Map constructor
  //       return [key, value];
  //     })
  //   );
  // }
  